import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableFAQ from './tableFAQ';

export default {
  title: 'FAQ Links',
  attributeName: 'faqTable',
  helpText: '',
  getURL:'appId/areaId/faqLinks',
  updateURL:'appId/areaId/faqLinks',
  removeURL:'appId/areaId/faqLinks',
  sessionParams: ['appId', 'areaId'],
  fields: [
    // {
    //   attributeName: 'externalLinks',
    //   type: FormInputTypes.TABLE,
    //   label: '',
    //   helpText: '',
    //   configFile: tableAppLinks,
    // },
    {
      attributeName: 'faqLinksTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'NORMAL',
      helpText: '',
      configFile: tableFAQ,
    },
  ],
};
